import { RemovableRef, get, set, useSessionStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed } from "vue";

/**
 * Store to manage the shop status and type.
 * It uses session storage to persist the state across sessions.
 * The store provides methods to check the connection, mock online/offline status,
 * and set the shop type and app entry path.
 */
export const useSapStore = defineStore("sap_shop", () => {
    // Define a session storage for the cartId
    const cartId: RemovableRef<string | undefined> = useSessionStorage("sap_shop_cartId", undefined);

    const setCartId = (id: string) => {
        set(cartId, id);
    };

    return {
        cartId: computed(() => get(cartId)),
        setCartId,
    };
});
